import FavoriteIcon from '@material-ui/icons/Favorite';

import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <p className="footer-text">Made with <FavoriteIcon className="heart" /> by
      <a href="https://github.com/JonesXavi/"> Jones</a>
    </p>
  </footer>
);

export default Footer;
